var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEmerg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 100,
    viewBox: "0 0 94 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43095 70.0361V75.1271C1.42873 75.4507 1.51564 75.7687 1.68216 76.0463C1.84868 76.3238 2.08838 76.5502 2.375 76.7005L43.9993 98.7541C45.01 99.289 46.1362 99.5686 47.2797 99.5686C48.4233 99.5686 49.5494 99.289 50.5602 98.7541L92.1845 76.7005C92.4711 76.5502 92.7108 76.3238 92.8773 76.0463C93.0438 75.7687 93.1307 75.4507 93.1285 75.1271V70.0361",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43095 70.0361V75.1271C1.42873 75.4507 1.51564 75.7687 1.68216 76.0463C1.84868 76.3238 2.08838 76.5502 2.375 76.7005L43.9993 98.7541C45.01 99.289 46.1362 99.5686 47.2797 99.5686C48.4233 99.5686 49.5494 99.289 50.5602 98.7541L92.1845 76.7005C92.4711 76.5502 92.7108 76.3238 92.8773 76.0463C93.0438 75.7687 93.1307 75.4507 93.1285 75.1271V70.0361",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1845 68.4629L50.5602 46.4136C49.5495 45.8787 48.4233 45.5991 47.2798 45.5991C46.1362 45.5991 45.0101 45.8787 43.9993 46.4136L2.37504 68.4629C2.08906 68.6143 1.84975 68.8408 1.68284 69.118C1.51593 69.3953 1.42773 69.7127 1.42773 70.0363C1.42773 70.3599 1.51593 70.6774 1.68284 70.9546C1.84975 71.2318 2.08906 71.4583 2.37504 71.6097L43.9993 93.6591C45.0101 94.1939 46.1362 94.4735 47.2798 94.4735C48.4233 94.4735 49.5495 94.1939 50.5602 93.6591L92.1845 71.6097C92.4693 71.4573 92.7073 71.2305 92.8733 70.9534C93.0393 70.6763 93.1269 70.3593 93.1269 70.0363C93.1269 69.7133 93.0393 69.3964 92.8733 69.1193C92.7073 68.8422 92.4693 68.6153 92.1845 68.4629Z",
    fill: "#F2F8FF",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9878 28.4939L55.4961 12.6736C50.0718 13.7966 44.475 13.7966 39.0507 12.6736L34.5632 28.4724C42.8483 31.0019 51.6985 31.0095 59.9878 28.4939Z",
    fill: "white",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4962 12.6735L52.7589 3.03474C52.5427 2.27996 52.0868 1.616 51.46 1.14319C50.8332 0.670367 50.0696 0.414355 49.2844 0.413818H45.2669C44.4817 0.414355 43.7181 0.670367 43.0913 1.14319C42.4645 1.616 42.0086 2.27996 41.7924 3.03474L39.0508 12.6907C44.4762 13.808 50.0731 13.8022 55.4962 12.6735Z",
    fill: "#F2F8FF",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3343 43.4045L26.071 58.4145C32.7807 61.2564 39.9931 62.7208 47.2798 62.7208C54.5665 62.7208 61.7788 61.2564 68.4885 58.4145L64.2252 43.4045C53.287 47.4308 41.2726 47.4308 30.3343 43.4045Z",
    fill: "white",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2253 43.4046L59.9879 28.4939C51.698 31.0182 42.8445 31.0182 34.5547 28.4939L30.3215 43.3917C41.2621 47.4253 53.2817 47.4299 64.2253 43.4046Z",
    fill: "#F2F8FF",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0712 58.4146L22.2735 71.7778C22.1708 72.1327 22.1956 72.5125 22.3437 72.8511C22.4917 73.1896 22.7536 73.4657 23.0839 73.6314C30.5865 77.4212 38.8744 79.3957 47.2799 79.3957C55.6854 79.3957 63.9734 77.4212 71.476 73.6314C71.8063 73.4657 72.0681 73.1896 72.2162 72.8511C72.3642 72.5125 72.389 72.1327 72.2864 71.7778L68.4887 58.4146C61.779 61.2564 54.5666 62.7209 47.2799 62.7209C39.9932 62.7209 32.7809 61.2564 26.0712 58.4146Z",
    fill: "#F2F8FF",
    stroke: "#BBBBBB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2798 4.40981C49.0749 4.40981 50.5301 3.98135 50.5301 3.45283C50.5301 2.9243 49.0749 2.49585 47.2798 2.49585C45.4847 2.49585 44.0295 2.9243 44.0295 3.45283C44.0295 3.98135 45.4847 4.40981 47.2798 4.40981Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmerg);
export default __webpack_public_path__ + "static/media/img_emerg.9134756e57b460c1e51cff1b5c652cfc.svg";
export { ForwardRef as ReactComponent };